export const eTipoDownload = {
    GestaoPedidos: 1,
    Clientes: 2,
}